import { GetProfileStatsQuery } from '@mp/graphql/generated/graphql';
import { graphql } from '../graphql/generated';
import { useGraphQLQuery } from './useGraphQLRequest';

const ProfileStatsGql = graphql(`
  query GetProfileStats {
    profileStats {
      no_shows_count
      late_cancellations_count
      do_not_sends_count
      favorites_count
      jobs_completed_count
      status
    }
  }
`);

export const useProfileStats = () => {
  const { data, isLoading, refetch } = useGraphQLQuery<GetProfileStatsQuery>({
    operationName: 'GetProfileStats',
    query: ProfileStatsGql,
    variables: {},
  });

  return {
    isLoading,
    no_shows_count: data?.profileStats?.no_shows_count || 0,
    late_cancellations_count: data?.profileStats?.late_cancellations_count || 0,
    do_not_sends_count: data?.profileStats?.do_not_sends_count || 0,
    favorites_count: data?.profileStats?.favorites_count || 0,
    jobs_completed_count: data?.profileStats?.jobs_completed_count || 0,
    status: data?.profileStats?.status || '',
    refetch,
  };
};
